import styled from "styled-components";
import { Text, TextLink } from "@origin-digital/ods-core";

export const StyledText = styled(Text)`
  && {
    padding: 0 0 14px 0;
    margin-top: 16px;
    white-space: pre-line;
  }
`;

export const StyledTextRoofPage = styled(Text)`
  && {
    padding: 0 0 24px 0;
    margin-top: 16px;
    white-space: pre-line;
  }
`;

export const UppercaseText = styled(Text)`
  && {
    text-transform: uppercase;
    margin-bottom: 8px;
  }
`;

export const UnderlinedText = styled(Text)(() => ({
  "&&": {
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export const TextLinkWithNoUnderline = styled(TextLink)(() => ({
  "&&": {
    textDecoration: "none",
  },
}));

export const StyledResponsiveText = styled(Text)(
  ({ theme: { breakpoints } }) => {
    const responsiveFontSize = {
      fontSize: "12px",

      [breakpoints.up("sm")]: {
        fontSize: "14px",
      },
    };

    return {
      "&&": {
        ...responsiveFontSize,
      },
    } as const;
  }
);

export const EllipsisTextLink = styled(TextLink)(() => ({
  "&&": {
    display: "inline-block",
    width: "calc(100%)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export const StyledHelperText = styled(Text)(() => ({
  "&&": {
    margin: 0,
    width: "max-content",
    color: "#ec0000",
    fontSize: "12px",
  },
}));
